import cx from 'classnames';
import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { priorities } from '../../../domain';
import { NormalizedAgents } from '../../../resources/agent/types';

import { DisplayDossiersTodo } from '../../../resources/todo/types';

import s from '../Todo.css';

import { DossierTodo } from './DossierTodo';

type Props = {
    dossiers: DisplayDossiersTodo;
    agents: NormalizedAgents;
    date: number | Date;
    nextDays?: boolean;
};

export const SingleDayTodo = ({ dossiers, agents, date, nextDays }: Props): JSX.Element => (
    <React.Fragment>
        <h1 className={cx(s.dateTitle, s.nextDays)}>
            <FormattedDate value={date} month="long" weekday="long" day="numeric" />
            {nextDays && <hr />}
        </h1>
        {priorities
            .filter((priority) => dossiers[priority] && dossiers[priority].length)
            .map((priority) => (
                <React.Fragment key={priority}>
                    {/* eslint-disable-next-line no-restricted-syntax -- CSS class name, not a color */}
                    <h2 className="white">
                        <FormattedMessage id={`todo.priority.${priority}`} />
                    </h2>
                    <div className={s[`${priority}Priority`]} data-testid={`${priority}-priority`}>
                        {dossiers[priority].map((dossier) => (
                            <DossierTodo
                                agent={agents[dossier.agentId]}
                                key={dossier.id}
                                value={dossier}
                            />
                        ))}
                    </div>
                </React.Fragment>
            ))}
    </React.Fragment>
);
